module.exports = __webpack_public_path__ + "img/auxilio_temporario.a43ae3dd.svg";